import { NoInputType } from '../InputTypes';
import { makeOperator } from './Operator';

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ inputType: "NONE"; name: strin... Remove this comment to see the full error message
export default makeOperator({
  inputType: NoInputType,
  name: 'Any'
});